import { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { Button, Typography } from "@mui/material";
import CohortsDropdown from "../FormComponents/CohortsDropdown";
import ServiceBranchDropdown from "../FormComponents/ServiceBranchDropdown";
import "./alumniFilter.scss";
import LocationFields from "../FormComponents/LocationFields";
import CheckboxControl from "../FormComponents/CheckboxControl";

const propTypes = {
  cohorts: PropTypes.objectOf(PropTypes.any).isRequired,
  allAlumni: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  setAlumniToDisplay: PropTypes.func.isRequired,
};

const AlumniFilter = ({ cohorts, allAlumni, setAlumniToDisplay }) => {
  const [isOpenToWork, setIsOpenToWork] = useState(false);
  const [isWillingToTravel, setIsWillingToTravel] = useState(false);
  const [isMilitarySpouse, setIsMilitarySpouse] = useState(false);
  const [clearLocationFields, setClearLocationFields] = useState(false);
  const [cohortID, setCohortID] = useState("");
  const [branch, setBranch] = useState("");
  const [location, setLocation] = useState({
    countryCode: "",
    stateCode: "",
    cityName: "",
  });

  useEffect(() => {
    const matchedAlumni = allAlumni.filter(
      (alum) =>
        (isOpenToWork ? alum.isOpenToWork : true) &&
        (isWillingToTravel ? alum.isWillingToTravel : true) &&
        (isMilitarySpouse ? alum.isMilitarySpouse : true) &&
        (cohortID ? alum.cohortID === cohortID : true) &&
        (branch ? alum.branch === branch : true) &&
        (location.countryCode
          ? alum.countryCode === location.countryCode
          : true) &&
        (location.stateCode ? alum.stateCode === location.stateCode : true) &&
        (location.cityName ? alum.cityName === location.cityName : true)
    );
    setAlumniToDisplay(matchedAlumni);
  }, [
    cohortID,
    branch,
    location,
    isOpenToWork,
    isWillingToTravel,
    isMilitarySpouse,
  ]);

  const handleClearFilter = () => {
    setIsOpenToWork(false);
    setIsWillingToTravel(false);
    setIsMilitarySpouse(false);
    setCohortID("");
    setBranch("");
    setLocation({
      countryCode: "",
      stateCode: "",
      cityName: "",
    });
    setClearLocationFields(true);
    setAlumniToDisplay(allAlumni);
  };

  return (
    <div className="alumni-filter">
      <Typography variant="h6" className="title">
        Filter Alumni
      </Typography>
      <CohortsDropdown
        cohorts={cohorts}
        value={cohortID}
        onChange={(e) => setCohortID(e.target.value)}
      />
      <ServiceBranchDropdown
        value={branch}
        onChange={(e) => setBranch(e.target.value)}
      />
      <LocationFields
        location={location}
        setLocation={setLocation}
        clearFields={clearLocationFields}
        setClearFields={setClearLocationFields}
      />
      <CheckboxControl
        label="Open to work"
        checked={isOpenToWork}
        onChange={(e) => setIsOpenToWork(e.target.checked)}
      />
      <CheckboxControl
        label="Willing to Travel"
        checked={isWillingToTravel}
        onChange={(e) => setIsWillingToTravel(e.target.checked)}
      />
      <CheckboxControl
        label="Military Spouse"
        checked={isMilitarySpouse}
        onChange={(e) => setIsMilitarySpouse(e.target.checked)}
      />
      <Button
        className="clear-button"
        color="secondary"
        onClick={handleClearFilter}
      >
        Clear
      </Button>
    </div>
  );
};

AlumniFilter.propTypes = propTypes;

export default AlumniFilter;
